export const aboutTimeline = [
  { year: '2018', title: '项目创立', description: '开云登录项目正式成立，创始团队汇聚了来自顶尖互联网公司的安全专家和工程师，致力于打造更安全、更便捷的登录解决方案。' },
  { year: '2019', title: '产品发布', description: '开云登录 V1.0 正式上线，首月即获得超过10万用户注册，创新的安全登录理念获得市场积极反馈。' },
  { year: '2020', title: '企业版推出', description: '发布企业级开云登录解决方案，支持SSO单点登录和权限管理，当年签约超过50家企业客户。' },
  { year: '2021', title: '用户突破千万', description: '开云登录累计注册用户突破1000万，服务范围覆盖全国及部分海外地区，成为登录认证领域的知名品牌。' },
  { year: '2022', title: '技术突破', description: '研发团队在无密码登录和AI自适应认证领域取得重大突破，获得多项国家发明专利。' },
  { year: '2023', title: '安全认证', description: '通过ISO 27001信息安全管理体系认证和国家信息安全等级保护三级认证，安全能力获权威认可。' },
  { year: '2024', title: '全球化布局', description: '启动全球化战略，在多国部署服务节点，支持多语言和多区域合规要求。' },
  { year: '2025', title: 'AI升级', description: '引入大语言模型驱动的智能安全引擎，风险评估准确率大幅提升，发布开云登录 V4.0。' },
  { year: '2026', title: '全新篇章', description: '开云登录 V5.0 发布，累计用户突破5000万，服务企业超过200家，持续引领登录认证行业发展。' },
];

export const certifications = [
  { name: 'ISO 27001 信息安全管理体系认证', icon: 'ri-award-line' },
  { name: '国家信息安全等级保护三级认证', icon: 'ri-shield-star-line' },
  { name: '可信云服务认证', icon: 'ri-cloud-line' },
  { name: 'SOC 2 Type II 审计报告', icon: 'ri-file-check-line' },
];

export const contactInfo = {
  phone: '400-888-0000',
  email: 'contact@kaiyun-login.com',
  address: '北京市海淀区中关村科技园区创新路88号开云大厦',
  workingHours: '周一至周五 9:00 - 18:00（法定节假日除外）',
};